export const apiGeocoding = {
	autocompleteRequest: async (input: string) => {
		const API_KEY = 'AIzaSyBno6WmpUhO65C5y8JFddiewTnKTK29h94'
		const data = await $fetch(
			`https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${input}&key=${API_KEY}
		`,
			{ method: 'GET' },
		)
		return data
	},
	decodeCoordinates: async (lat: number, lng: number) => {
		// const type = 'locality'
		const API_KEY = 'AIzaSyBno6WmpUhO65C5y8JFddiewTnKTK29h94'
		const language = 'pl'
		const data = await $fetch(
			`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}
		&language=${language}&key=${API_KEY}
		`,
			{ method: 'GET' },
		)
		return data as { status: string; results: any[] }
	},
}
